import * as React from 'react';
import { ActivityFeedItem } from '../service/ActivityFeedItem';
import { EmptyStateView } from './EmptyStateView';
import { ActivityFeedActionType } from './ActivityFeedActions';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { activityFeedClearAll } from './ActivityFeedView.locstring.json';
import ActivityFeedCard from './ActivityFeedCard';
import loc from 'owa-localize';
import { getActivityCardPresentationDetails } from '../utils/feedCardPresentationDetails';
import { Action } from 'adaptivecards';
export interface ActivityFeedViewProps {
    cards: ActivityFeedItem[];
    onAction?: (itemId: string, action: ActivityFeedActionType) => void;
    onAdaptiveCardAction?: (itemId: string, action: Action) => void;
    onDismissAll: () => void;
}

const styles = require('./ActivityFeed.scss');

export function ActivityFeedViewV2(props: ActivityFeedViewProps) {
    const isFeedEmpty = props.cards.length === 0;

    const cards = isFeedEmpty ? (
        <EmptyStateView />
    ) : (
        props.cards.map(feedItem => (
            <ActivityFeedCard
                key={feedItem.id}
                itemId={feedItem.id}
                item={getActivityCardPresentationDetails(feedItem)}
                onAction={props.onAction}
            />
        ))
    );
    return (
        <>
            <div className={styles.header}>
                <Link
                    className={styles.clearAll}
                    disabled={isFeedEmpty}
                    onClick={props.onDismissAll}>
                    {loc(activityFeedClearAll)}
                </Link>
            </div>
            <div className={styles.feed}>{cards}</div>
        </>
    );
}
